"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_COORDINATES_API_RESPONSE_400 = exports.GET_COORDINATES_API_RESPONSE_200 = void 0;
var coordinates_1 = require("./coordinates");
Object.defineProperty(exports, "GET_COORDINATES_API_RESPONSE_200", { enumerable: true, get: function () { return coordinates_1.GET_COORDINATES_API_RESPONSE_200; } });
Object.defineProperty(exports, "GET_COORDINATES_API_RESPONSE_400", { enumerable: true, get: function () { return coordinates_1.GET_COORDINATES_API_RESPONSE_400; } });
//# sourceMappingURL=index.js.map